import React, { useState } from "react"
import styled from "@emotion/styled"
import { useFeatureIsOn } from "@growthbook/growthbook-react"

import AlertBanner from "../ui/alert-banner"

import mercadoPagoLogo from "../../images/mercadopago-logo.svg"
import visaMasterCardLogo from "../../images/visamastercard.svg"
import PeruCreditCard from "../nuvei/peru/credit-card"
import MercadoPagoPeruView from "../mercadopago/mercadopago-peru"

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
`

const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
`

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 1rem 0;
  margin: 1rem 0 2rem;
  width: 217px;
  min-height: 100px;
  cursor: pointer;
`

const get_text_important = () => (
  <>
    <strong>IMPORTANTE:</strong> En algunos casos podrá existir un costo por procesamiento de hasta un 3.76%, el cual será descontado del monto depositado.
  </>
)

const PayOnlinePeru = () => {
  const isMercadoPagoEnabled = useFeatureIsOn("payment-mercadopago-peru")
  const [selectProvider, setSelectProvider] = useState<"creditcard" | "mercadopago" | null>(null)

  const onClickCreditCard = () => {
    setSelectProvider("creditcard")
  }

  const onClickMercadoPago = () => {
    setSelectProvider("mercadopago")
  }

  const methodPayment = {
    "creditcard": PeruCreditCard,
    "mercadopago": MercadoPagoPeruView,
  }

  let ProviderSelected: any = <></>

  if (selectProvider !== null) {
    ProviderSelected = methodPayment[selectProvider]
  }

  return (
    <Content>
      <ContainerButton>
        {selectProvider === null && (
          <>
            <Box onClick={onClickCreditCard}>
              <img src={visaMasterCardLogo} alt="Visa Mastercard" style={{ width: "190px" }} />
            </Box>
            {isMercadoPagoEnabled && (
              <Box onClick={onClickMercadoPago}>
                <img src={mercadoPagoLogo} alt="Mercado Pago" style={{ width: "190px" }} />
              </Box>
            )}
          </>
        )}
        {selectProvider !== null && <ProviderSelected />}
      </ContainerButton>
      <AlertBanner> {get_text_important()} </AlertBanner>
    </Content>
  )
}

export default PayOnlinePeru
